import styled from '@emotion/styled';
import { Wws_Page } from '../../../../types/graphql';
import SinglePageDesktopNavContainer from './SubComponents/SinglePageDesktopNavContainer';
import SinglePageDesktopNavMenuButton from './SubComponents/SinglePageDesktopNavMenuButton';
import { useState } from 'react';
import SinglePageDesktopNavMenu from './SubComponents/SinglePageDesktopNavMenu';
import useTracking from '../../../../lib/useTracking';
import { useCurrentRoute } from '../../../../lib/useCurrentRoute';

interface SinglePageDesktopNavProps {
  pages?: Wws_Page[];
}

const NavWrapper = styled('div')`
  position: fixed;
  top: 0;
  display: flex;
  flex-direction: column;
  align-items: start;
  margin: 16px;
  row-gap: 10px;
`;

const SinglePageDesktopNav = ({ pages = [] }: SinglePageDesktopNavProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const currentRoute = useCurrentRoute();

  const trackNavMenuToggle = useTracking(
    'leftNav',
    currentRoute,
    'nav menu toggle'
  );

  const toggleMenu = () => {
    const selection = isMenuOpen ? 'close' : 'open';
    trackNavMenuToggle(`${selection} menu`);

    setIsMenuOpen((prev) => !prev);
  };

  return (
    <SinglePageDesktopNavContainer>
      <NavWrapper data-testid="SinglePageDesktopNav__Nav__Container">
        <SinglePageDesktopNavMenuButton
          onClick={toggleMenu}
          isMenuOpen={isMenuOpen}
        />
        <SinglePageDesktopNavMenu
          pages={pages}
          isMenuOpen={isMenuOpen}
          setIsMenuOpen={(isOpen: boolean) => setIsMenuOpen(isOpen)}
        />
      </NavWrapper>
    </SinglePageDesktopNavContainer>
  );
};

export default SinglePageDesktopNav;
